let district = [
    { "x": -1, "y": -1, "type": "right", "opts": "start", "pickup": false },
    { "x": -2, "y": -1, "type": "right" },
    { "x": -3, "y": -1, "type": "right" },
    { "x": -4, "y": -1, "type": "righttop" },
    { "x": -5, "y": -2, "type": "top" },
    { "x": -6, "y": -3, "type": "topleft" },
    { "x": -6, "y": -4, "type": "left" },
    { "x": -6, "y": -5, "type": "lefttop" },
    { "x": -7, "y": -6, "type": "topright" },
    { "x": -8, "y": -6, "type": "right" },
    { "x": -9, "y": -6, "type": "right" },
    { "x": -10, "y": -6, "type": "voidright" },
    { "x": -11, "y": -6, "type": "righttop" },
    { "x": -12, "y": -7, "type": "top" },
    { "x": -13, "y": -8, "type": "top" },
    { "x": -14, "y": -9, "type": "top" },
    { "x": -15, "y": -10, "type": "topleft" },
    { "x": -15, "y": -11, "type": "left" },
    { "x": -15, "y": -12, "type": "voidleft" },
    { "x": -15, "y": -13, "type": "voidleft" },
    { "x": -16, "y": -15, "type": "lefttoright" },
    { "x": -17, "y": -15, "type": "right" },
    { "x": -18, "y": -15, "type": "right" },
    { "x": -20, "y": -16, "type": "righttoleft" },
    { "x": -21, "y": -18, "type": "lefttoright" },
    { "x": -23, "y": -19, "type": "righttoleft" },
    { "x": -23, "y": -20, "type": "voidleft" },
    { "x": -23, "y": -21, "type": "left" },
    { "x": -23, "y": -22, "type": "left" },
    { "x": -23, "y": -23, "type": "left" },
    { "x": -23, "y": -24, "type": "voidleft" },
    { "x": -23, "y": -25, "type": "left" },
    { "x": -24, "y": -27, "type": "lefttoright" },
    { "x": -25, "y": -27, "type": "right" },
    { "x": -26, "y": -27, "type": "right" },
    { "x": -27, "y": -27, "type": "righttop" },
    { "x": -28, "y": -28, "type": "voidbottop" },
    { "x": -29, "y": -29, "type": "top" },
    { "x": -30, "y": -30, "type": "topleft" },
    { "x": -30, "y": -31, "type": "lefttop" },
    { "x": -31, "y": -32, "type": "topright", "pickup": false },
    { "x": -32, "y": -32, "type": "right", "opts": "end", "pickup": false }
];
export default district;